import { useQuery } from '@tanstack/react-query'
import { apiFetch } from '@shared/api/http'
import { useSession } from '@shared/lib/auth/session-store'
import { ReceivingPlansResponseSchema } from '../model/user-receiving-plan'

export function useReceivingPlanQuery() {
  const userId = useSession((state) => state.user?.id)
  return useQuery({
    queryKey: ['receiving-plan', userId],
    enabled: Boolean(userId),
    queryFn: async () =>
      ReceivingPlansResponseSchema.parse(await apiFetch('/users/receiving-plan')),
    staleTime: 0,
    refetchOnWindowFocus: true,
  })
}
